import { createContext } from 'react'

import { WebRTC } from './WebRTC'

export const webRTCContext = createContext<WebRTC | null>(null)

webRTCContext.displayName = 'WebRTCContext'
